import {
  ActivityRowStats,
  RankedListPanel,
  hasActivityScore,
} from './AnalyticsRankedList';

function AdminClientActivityLists({ regionRows, topicRows, onRegionClick }) {
  const sortedRegions = [...regionRows]
    .filter((row) => hasActivityScore(row.relativeScore))
    .sort((a, b) => {
      if (b.relativeScore !== a.relativeScore) return b.relativeScore - a.relativeScore;
      return String(a.regionName).localeCompare(String(b.regionName));
    });

  const courseGroups = (topicRows || [])
    .map((course) => ({
      ...course,
      lessons: [...(course.lessons || [])]
        .filter((lesson) => hasActivityScore(lesson.relativeActivity))
        .sort((a, b) => {
          if (b.relativeActivity !== a.relativeActivity) return b.relativeActivity - a.relativeActivity;
          return String(a.lessonTitle).localeCompare(String(b.lessonTitle));
        }),
    }))
    .filter((course) => course.lessons.length > 0);

  return (
    <>
      <h2 className="modern-heading analytics-section-heading modern-mb-4">Regions</h2>
      <RankedListPanel
        items={sortedRegions}
        getKey={(row) => row.regionId}
        getLabel={(row) => row.regionName}
        getActivityScore={(row) => row.relativeScore}
        renderMeta={(row) => (
          <ActivityRowStats reflections={row.totalReflections} />
        )}
        onItemClick={onRegionClick}
        emptyMessage="No active regions yet."
      />

      <h2 className="modern-heading analytics-section-heading modern-mb-4 modern-mt-6">Topics</h2>
      {courseGroups.length === 0 ? (
        <div className="modern-list-panel">
          <div className="modern-list-empty">No course topic activity found.</div>
        </div>
      ) : (
        courseGroups.map((course) => (
          <div key={course.courseId} className="analytics-ranked-group">
            <h3 className="analytics-ranked-group-title">{course.courseName}</h3>
            <RankedListPanel
              items={course.lessons}
              getKey={(lesson) => lesson.lessonId}
              getLabel={(lesson) => lesson.lessonTitle}
              getActivityScore={(lesson) => lesson.relativeActivity}
              activityColor="#6E9277"
              renderMeta={(lesson) => (
                <ActivityRowStats reflections={lesson.reflections} />
              )}
              emptyMessage="No topic activity for this course."
            />
          </div>
        ))
      )}
    </>
  );
}

export default AdminClientActivityLists;
